

import '../blocks/components/preloader/preloader.js';
import '../blocks/components/structural-risks/structural-risks.js';
import '../blocks/components/promo/promo.js';
import '../blocks/components/investment-sites/investment-sites.js';

import '../blocks/components/faq/faq.js';
import '../blocks/components/about-team/about-team.js';
import '../blocks/components/team/team.js';
import '../blocks/components/open-positions/open-positions.js';
import '../blocks/components/effectiveness-strategy/effectiveness-strategy.js';
import '../blocks/components/strategy-tools/strategy-tools.js';
import '../blocks/components/quiz/quiz.js';
import '../blocks/components/article/article.js';



import '../blocks/modules/header/header.js';
import '../blocks/modules/summary/summary.js';
import '../blocks/modules/modal/modal.js';
import '../blocks/modules/footer/footer.js';


import '../blocks/components/animation/animation.js';

